import { CompactTable } from '@table-library/react-table-library/compact';
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';
import { usePagination } from "@table-library/react-table-library/pagination";
import Styles from '../users/users.module.scss'
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiEye, FiFilter, FiSearch, FiCalendar } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { resetAppointmentNotification } from "../../store/notification/notificationActions";
import { getAppointmentList } from "../../store/appointment/appointmentActions";
import moment from "moment";
import NotFoundWidget from '../../components/widgets/NotFound';
import { TablePagination } from '../../components/global/table-pagination';

const AdminAppointmentList = () => {
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState([]);

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAppointmentList({}))
            .unwrap()
            .then((v) => setNodes(v))
        dispatch(resetAppointmentNotification())
    }, [])

    const [nodes, setNodes] = useState([]);

    const COLUMNS = [
        {
            label: 'Tutor', class: "avatar", renderCell: (item) => {
                return <p className="capitalize font-medium text-nt-blue">{item.tutor}</p>
            },
            pinLeft: true,
        },
        {
            label: 'Student',
            renderCell: (item) => <p className="capitalize font-medium text-nt-blue">{item.student}</p>,
            pinLeft: true,

        },
        {
            label: 'Price',
            renderCell: (item) => item.price ? item.price + " €" : '',
            pinLeft: true,

        },
        {
            label: 'Date',
            renderCell: (item) => {
                return moment(item.date).utc().format("YYYY-MM-DD").toString()
            },
            pinLeft: true,
        },
        {
            label: 'Time',
            renderCell: (item) => moment(item.date).parseZone().format("HH:mm").toString() + " - " + moment(item.date).parseZone().add(50, "minutes").format("HH:mm").toString(),
            pinLeft: true,

        },
        {
            label: 'Status', renderCell: (item, index) => {
                return (
                    <div className={Styles.profileList}>
                        <AppointmentStatus status={item.status} />

                    </div>
                )
            },
            pinLeft: true,
        },
        {
            label: '',
            renderCell: (item, index) => {
                return <Link className={Styles.viewBtn} to={`/appointment/detail/${item._id}`}>
                    <FiEye />
                    <span>View</span>
                </Link>
            },
            pinLeft: true,

        },
    ];

    const AppointmentStatus = ({ status }) => {
        if (status === -1) {
            return <span className={`bg-nt-blue text-white px-2 rounded py-1`}>Pending</span>
        } else if (status === 0) {
            return <span className={`bg-nt-blue text-white px-2 rounded py-1`}>Pending Payment</span>
        } else if (status === 1) {
            return <span className={`bg-green text-white px-2 rounded py-1`}>Done</span>
        } else if (status === 2) {
            return <span className={`bg-red text-white px-2 rounded py-1`}>Canceled</span>
        } else if (status === 3) {
            return <span className={`bg-green opacity-70 text-white px-2 rounded py-1`}>Under Review</span>
        } else if (status === 4) {
            return <span className={`bg-red opacity-70 text-white px-2 rounded py-1`}>Payment Rejected</span>
        }
    }
    const theme = useTheme([getTheme(), {
        HeaderRow: `color: #191D51;`,
        Table: `--data-table-library_grid-template-columns: 150px auto 200px 200px 200px 200px 200px; width:auto;min-width:auto;min-height:auto;`
    }]);

    let data = { nodes };

    data = {
        nodes: data.nodes.filter((item) =>
            (
                item.tutor?.toLowerCase().includes(search.toLowerCase()) ||
                item.student?.toLowerCase().includes(search.toLowerCase()) ||
                item.date.toLowerCase().includes(search.toLowerCase())
            ) && (filter.length && filter.includes(item.status) || filter.length === 0)
        ),
    };

    const pagination = usePagination(data, {
        state: {
            page: 0,
            size: 5,
        },
    });

    const pageButtonCount = 2;
    const totalPages = pagination.state.getTotalPages(data.nodes)
    const pages = pagination.state.getPages(data.nodes);

    const toggleFilter = (status) => {
        pagination.fns.onSetPage(0)
        if (filter.includes(status))
            setFilter(x => x.filter(v => v != status))
        else
            setFilter(x => [...x, status])
    }
    return (
        <div className={Styles.tableContainer}>
            <div className="mb-5 rounded-2xl border border-slate-200 bg-slate-50 p-4 sm:p-5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-center gap-3">
                        <div className="grid h-10 w-10 place-items-center rounded-xl bg-nt-blue/10 text-nt-blue">
                            <FiCalendar size={18} />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-nt-blue">Appointments</h2>
                            <p className="text-sm text-nt-grey">All tutor and student bookings across the platform</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <p className="text-sm text-nt-grey">
                    {data.nodes.length} result{data.nodes.length === 1 ? "" : "s"}
                </p>
                <label htmlFor="search" className="relative w-full sm:w-[300px]">
                    <FiSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-nt-grey" size={16} />
                    <input
                        id="search"
                        type="text"
                        placeholder="Search by tutor, student, or date..."
                        className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm outline-none transition focus:border-nt-blue focus:ring-2 focus:ring-nt-blue/10"
                        value={search}
                        onChange={handleSearch}
                    />
                </label>
            </div>

            <div className="mb-5 flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-slate-50/80 p-3">
                <FiFilter className="shrink-0 text-nt-blue" size={18} aria-hidden />
                <span onClick={() => toggleFilter(-1)} className={`${filter.includes(-1) ? "text-white bg-nt-blue" : "text-nt-blue bg-white"} border border-slate-200 select-none rounded-lg px-2.5 py-1 text-sm cursor-pointer transition hover:opacity-90`}>Pending</span>
                <span onClick={() => toggleFilter(0)} className={`${filter.includes(0) ? "text-white bg-nt-blue" : "text-nt-blue bg-white"} border border-slate-200 select-none rounded-lg px-2.5 py-1 text-sm cursor-pointer transition hover:opacity-90`}>Pending Payment</span>
                <span onClick={() => toggleFilter(1)} className={`${filter.includes(1) ? "text-white bg-nt-blue" : "text-nt-blue bg-white"} border border-slate-200 select-none rounded-lg px-2.5 py-1 text-sm cursor-pointer transition hover:opacity-90`}>Done</span>
                <span onClick={() => toggleFilter(2)} className={`${filter.includes(2) ? "text-white bg-nt-blue" : "text-nt-blue bg-white"} border border-slate-200 select-none rounded-lg px-2.5 py-1 text-sm cursor-pointer transition hover:opacity-90`}>Canceled</span>
                <span onClick={() => toggleFilter(3)} className={`${filter.includes(3) ? "text-white bg-nt-blue" : "text-nt-blue bg-white"} border border-slate-200 select-none rounded-lg px-2.5 py-1 text-sm cursor-pointer transition hover:opacity-90`}>Under Review</span>
                <span onClick={() => toggleFilter(4)} className={`${filter.includes(4) ? "text-white bg-nt-blue" : "text-nt-blue bg-white"} border border-slate-200 select-none rounded-lg px-2.5 py-1 text-sm cursor-pointer transition hover:opacity-90`}>Payment Rejected</span>
            </div>
            
            <CompactTable columns={COLUMNS} layout={{ custom: true, horizontalScroll: true, }} data={data} theme={theme} pagination={pagination} />
            
            { nodes.length === 0 ? <NotFoundWidget message="No Appointment History" /> : null }
            {totalPages > 0 ? <TablePagination
                pageButtonCount={pageButtonCount}
                totalPages={totalPages}
                pagination={pagination}
                pages={pages}
            /> : null}
        </div>

    )
}

export { AdminAppointmentList }